import {Component} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ChangePasswordModel} from '../models/change-password-model';
import {Observable} from 'rxjs/Observable';
import * as fromRoot from '../reducers';
import * as actions from '../actions/authentication';
import {Store} from '@ngrx/store';

@Component({
  selector: 'app-change-password',
  template: `
    <div class="row justify-content-center" style="padding-top:20px;">
      <div class="col-md-4">
        <div class="card">
          <div class="card-header">
            <h6 class="text-center">Change Password</h6>
          </div>
          <div class="card-body">
            <form (ngSubmit)="changePassword()">
              <div class="form-group text-center">
                <div class="small italic">Passwords must be at least 8 characters in length,<br/>contain an uppercase
                  and
                  lowercase letter, <br/>a number, and a special character.
                </div>
              </div>
              <div class="form-group"
                   [ngClass]="{'has-error':!pwForm.controls['oldPassword'].valid && pwForm.controls['oldPassword'].touched}">
                <label>Current Password</label>
                <input type="password" class="form-control" [formControl]="pwForm.controls['oldPassword']">
              </div>
              <div class="form-group"
                   [ngClass]="{'has-error':!pwForm.controls['newPassword'].valid && pwForm.controls['newPassword'].touched}">
                <label>New Password</label>
                <input type="password" 
                       class="form-control"
                       (keyup)="checkPasswordMatch()"
                       [formControl]="pwForm.controls['newPassword']">
              </div>
              <div class="form-group"
                   [ngClass]="
               {'has-error':(!pwForm.controls['confirmPassword'].valid && pwForm.controls['confirmPassword'].touched) ||
               (!pwMatches && pwForm.controls['confirmPassword'].touched)}">
                <label>Confirm Password</label>
                <input
                  type="password"
                  class="form-control"
                  [formControl]="pwForm.controls['confirmPassword']"
                  (keyup)="checkPasswordMatch()">
              </div>
              <div class="small italic red center"
                   *ngIf="!pwForm.controls['newPassword'].valid && pwForm.controls['newPassword'].touched">
                New password does not meet the minimum requirements.
              </div>
              <div class="small italic red center" *ngIf="!pwMatches && pwForm.controls['confirmPassword'].touched">
                New password and confirmed password do not match.
              </div>
              <button class="btn btn-sm btn-outline-primary btn-block" [disabled]="(working$ | async) || !pwMatches">
                <span *ngIf="working$ | async">Changing Password</span>
                <span *ngIf="!(working$ | async)">Change Password</span>
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .italic {
      font-style: italic;
      line-height: 15px;
    }
    .red {
      color:red;
      padding:5px;
    }
  `]
})
export class ChangePasswordPageComponent {

  public pwForm: FormGroup;
  public working$: Observable<boolean>;
  public pwMatches = true;

  constructor(private store: Store<fromRoot.State>,
              private fb: FormBuilder) {
    this.pwForm = this.fb.group({
      'oldPassword': [null, Validators.required],
      'newPassword': [null,
        Validators.pattern(
          /^(?=.*[0-9])(?=.*[A-z])(?=.*[$&+,:;=?@#|'<>.^*()%!-])[0-9A-z$&+,:;=?@#|'<>.^*()%!-]{8,20}$/)],
      'confirmPassword': [null, Validators.required]
    });
    this.working$ = this.store.select(fromRoot.getAuthWorking);
  }

  public checkPasswordMatch() {
    let newpassword: string, confirmpassword: string;
    newpassword = this.pwForm.controls['newPassword'].value;
    confirmpassword = this.pwForm.controls['confirmPassword'].value;
    if (newpassword !== confirmpassword) {
      this.pwMatches = false;
      return;
    } else {
      this.pwMatches = true;
    }
  }

  public changePassword() {
    if (!this.pwForm.valid || !this.pwMatches) {
      this.pwForm.controls['oldPassword'].markAsTouched();
      this.pwForm.controls['newPassword'].markAsTouched();
      this.pwForm.controls['confirmPassword'].markAsTouched();
      return;
    }

    this.store.dispatch(new actions.ChangePasswordAction(this.pwForm.value as ChangePasswordModel));
  }
}





// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/core/containers/change-password.ts